import React, { useState, useEffect, useCallback } from "react";
import { toastr } from "react-redux-toastr";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../components/Table/Table";
import { getIvtFilters, getIvtList } from "../../reducers/ivt/selector";
import { Ivt } from "../../services/Ivt";
import ContentHeader from "../../components/ContentHeader/ContentHeader";
import SimpleAccordion from "../../components/Accordion/Accordion";
import BlurLinearIcon from "@material-ui/icons/BlurLinear";
import FilterBox from "./layouts/FilterBox";

const icon = <BlurLinearIcon fontSize="inherit" color="primary" />;
const List = (props) => {
  const headers = [
    { title: "Date", value: "date" },
    { title: "Publisher", value: "publisher_id" },
    { title: "Publisher Name", value: "publisher_name" },
    { title: "Publisher channel id", value: "publisher_channel_id" },
    { title: "Search count", value: "server_search_count" },
    { title: "Traffic type", value: "advertiser_channel_traffic_type" },
    { title: "Number of user agents", value: "distinct_user_agent_count" },
    { title: "Observed KW score", value: "kw_score" },
    { title: "Number of ip repetion", value: "repetitive_ip_address_count" }
  ];

  const dispatch = useDispatch();
  const ivtList = useSelector(getIvtList);
  const filters = useSelector(getIvtFilters);
  const stableDispatch = useCallback(dispatch, [dispatch]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [orderBy, setOrderBy] = useState(filters.orderBy);
  const [orderDirection, setOrderDirection] = useState(filters.orderDirection);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const actions = [];

  const fetchIvtList = useCallback(async () => {
    setLoading(true);
    const {
      orderBy,
      orderDirection,
      publisher,
      trafficType,
      fromDate,
      toDate
    } = filters;
    await Ivt.getList({
      page,
      size,
      orderBy,
      orderDirection,
      publisher,
      trafficType,
      fromDate: fromDate.format("YYYY-MM-DD"),
      toDate: toDate.format("YYYY-MM-DD")
    })
      .then((response) => {
        const { ivt_list, count } = response.body;
        setTotal(count[0].count);
        stableDispatch({
          type: "SET_IVT_LIST",
          payload: ivt_list
        });
      })
      .catch((error) => {
        toastr.error("Error", error.message);
      });
    setLoading(false);
  }, [stableDispatch, page, size, filters]);

  useEffect(() => {
    fetchIvtList();
  }, [fetchIvtList]);

  return (
    <div className="ivt-container">
      <div className="ivt_container__header">
        <ContentHeader icon={icon} title="IVT" />
      </div>
      <div className="ivt_container__filter-box" style={{ marginBottom: 20 }}>
        <SimpleAccordion header="Filters" key="ivt-filterbox" expanded={true}>
          <FilterBox />
        </SimpleAccordion>
      </div>

      <Table
        noCheckboxes={true}
        headers={headers}
        noActions={true}
        rowValues={ivtList}
        tableType="ivt"
        page={page}
        setPage={setPage}
        size={size}
        actions={actions}
        setSize={setSize}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        orderDirection={orderDirection}
        setOrderDirection={setOrderDirection}
        total={total}
        isLoading={loading}
        rowsPerPageOptions={[10, 25, 50, 100, 150, 200]}
      />
    </div>
  );
};

export default List;
